export const TEAMS_STALE_TIME_MS = 5 * 60 * 1000;

export const teamsQueryKeys = {
  all: () => ['teams'] as const,
  list: () => [...teamsQueryKeys.all(), 'list'] as const,
};
